<template>
  <article class="example-page">
    <h1>Accordion</h1>
    <div class="accordion-container">
      <expandable-section>
        <span slot="title">Title</span>
        <div slot="content" class="expandable-section-content">
          <p>
            Spicy jalapeno bacon ipsum dolor amet laboris ea ullamco venison
            tri-tip. Consectetur pork belly dolore ut aliquip. Swine brisket
            reprehenderit deserunt mollit. Pork loin pancetta aute, andouille
            chicken doner turkey ground round shankle irure lorem drumstick
            picanha pariatur magna. Ground round pork chop fatback pariatur,
            tongue pancetta meatloaf cupim leberkas rump deserunt laboris.
            Drumstick commodo sirloin est exercitation. Sirloin ham hock
            ullamco, meatloaf flank beef capicola.
          </p>
          <p>
            Sunt culpa boudin, nostrud short loin sint excepteur sed. Pastrami
            chuck anim est ipsum, shankle officia hamburger cupidatat. Officia
            rump cow ham landjaeger in. Ut id ut fugiat pastrami kevin et
            veniam. Elit bresaola prosciutto quis tenderloin fugiat.
          </p>
        </div>
      </expandable-section>
      <expandable-section>
        <span slot="title">Other one</span>
        <div slot="content" class="expandable-section-content">
          <p>
            Doner landjaeger culpa pork loin, tail tenderloin sed eu meatball.
            Esse consequat tail ullamco minim ham hock non irure sed shank
            venison swine jowl. Pancetta pig pork loin pork chop jowl, capicola
            anim andouille salami ea chuck sausage. Swine excepteur cupidatat
            ut boudin pork loin. Commodo culpa alcatra venison ut shank et
            tri-tip lorem fugiat tail pig reprehenderit irure leberkas. Enim
            consequat proident, filet mignon leberkas rump magna cupidatat
            nisi.
          </p>
          <p>
            Pork loin ball tip shoulder drumstick ad in sunt. Labore flank
            sirloin deserunt velit. Brisket ullamco irure frankfurter eiusmod.
            Jerky commodo eiusmod cupim aliquip prosciutto.
          </p>
        </div>
      </expandable-section>
    </div>
  </article>
</template>

<script>
import { expandableSection } from '@/components/layout';

export default {
  name: 'Accordion',
  head: {
    title: 'Accordion | PPI Valet',
  },
  components: { expandableSection },
};

</script>

<style lang="scss" scoped>


  .accordion-container {
    max-width: 40em;
    margin: 0 auto;
  }

  .expandable-section {
    border: 1px solid $pearl-300;
    border-bottom-width: 0;

    &:last-child {
      border-bottom-width: 1px;
    }

    .expandable-section-content {
      padding: 0.5rem 0.5rem 0.75rem;
    }
  }

  p + p {
    margin-top: 0.75rem;
  }
</style>
